import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import Et3Tooltip from "../../core/et3-tooltip";
import { Gender } from "../../Types";
import {
  REACTION_BADGE_RADIUS,
  REACTION_BADGE_SIZE,
  REACTION_EMOJI_FONT_SIZE
} from "./reaction-constants";

const ReactionBadge = withLiteObserverAndTheme<{
  reaction: string;
  gender: string;
  isSuppressed: number;
}>((props) => {
  const { theme, reaction, gender, isSuppressed } = props;
  const { colors, unitX } = theme;
  const isFemale = gender === Gender.Female;
  const badgeColor = isFemale ? colors.all.pink : colors.all.deepSkyBlue;
  const isReactionSuppressed = isSuppressed === 1;

  const badge = (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={REACTION_BADGE_SIZE}
      height={REACTION_BADGE_SIZE}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={badgeColor}
      style={{
        boxSizing: "border-box",
        borderRadius: REACTION_BADGE_RADIUS * unitX,
        border: isReactionSuppressed
          ? `${2 * unitX}px dashed ${colors.all.red}`
          : "none",
        flexShrink: 0
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily="MEDIUM"
        fontSize={REACTION_EMOJI_FONT_SIZE}
        text={reaction}
        isSpan={true}
        color={colors.all.black}
        style={{}}
      />
    </ET3Div>
  );

  return isReactionSuppressed ? (
    <Et3Tooltip title={i18n.get("REACTION_SUPPRESSED")} placement="top">
      {badge}
    </Et3Tooltip>
  ) : (
    badge
  );
});
export default ReactionBadge;
